<template>
	<div>
		<el-tabs v-model="activeName" @tab-click="handleClick">
			<el-tab-pane label="待支付" name="tab1">
				<el-row>
					<el-col :span="24" v-for="(li,index) in getMorders('0')">
						<el-card v-if="showtab1" :body-style="{ padding: '0px' }">
							<div>
								<li>
									<span class="spanlabel">日期：{{formatdate(li.createdate)}}</span>
									<span class="spantxt">金额：￥{{li.order_price}}</span>
									<span class="spanlabel">订单编号：{{li.morder_id}}</span>

								</li>
								<li>
									<el-button size="mini" type="danger" round @click="ToPay(li)">去支付</el-button>
									<el-button size="mini" type="success" round @click="CancelOrder(li)">取消订单</el-button>
								</li>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-tab-pane>

			<el-tab-pane label="已支付" name="tab2">
				<el-row>
					<el-col :span="24" v-for="(li,index) in getMorders('1')">
						<el-card v-if="showtab2" :body-style="{ padding: '2px' }">
							<div>
								<ul style="width: 100%;float: left;text-align: left;">
									<li>
										<span class="spanlabel">订单编号：</span>
										<span class="spantxt">{{li.morder_id}}</span>
									</li>
									<li>
										<span class="spanlabel">日期：</span>
										<span class="spantxt">{{formatdate(li.createdate)}}</span>
									</li>
									<li>
										<span class="spanlabel">金额：</span>
										<span class="spantxt">￥{{li.order_price}}</span>
									</li>
									<li>
										<el-button size="mini" type="success" round @click="ToBook()">预约体检</el-button>
										<el-button size="mini" type="success" round @click="ToShowDetail(li)">订单详情</el-button>
										<el-button size="mini" type="danger" round @click="ToRefund(li)">申请退款</el-button>
									</li>
								</ul>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-tab-pane>
			<el-tab-pane label="申请退款" name="tab3">
				<el-row>
					<el-col :span="24" v-for="(li,index) in getMorders('2')">
						<el-card v-if="showtab3" :body-style="{ padding: '2px' }">
							<div>
								<ul style="width: 100%;float: left;text-align: left;">
									<li>
										<span class="spanlabel">订单编号：</span>
										<span class="spantxt">{{li.morder_id}}</span>
									</li>
									<li>
										<span class="spanlabel">日期：</span>
										<span class="spantxt">{{formatdate(li.createdate)}}</span>
									</li>
									<li>
										<span class="spanlabel">金额：</span>
										<span class="spantxt">￥{{li.order_price}}</span>
									</li>
									<li>
										<el-button size="mini" type="danger" round @click="ToRefundAli(li)">退款未到账</el-button>
									</li>
								</ul>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
		<el-drawer :visible.sync="showDetail" :with-header="false" :size='size'>
			<morderdetail v-if="showDetail" :inmorderid="selmorderid"></morderdetail>
		</el-drawer>
	</div>
</template>

<script>
	import member from '../../apifunction/Member.js'
	import morderdetail from './MOrderDetail.vue'
	import pay from '../../apifunction/OnlinePay.js';
	export default {
		created() {
			this.userent = this.$myglobal.getUserInfo();
			this.InitData();
		},
		components: {
			morderdetail
		},
		data() {
			return {
				userent: null,
				MOrderList: [],
				activeName: 'tab1',
				showtab1: true,
				showtab2: false,
				showtab3: false,
				size: '300px',
				selmorderid: '',
				showDetail: false
			}
		},
		methods: {
			ToRefund(row) {
				this.$confirm('确定要‘申请退款’吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					member.RefundShopOrder(row.morder_id)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								this.ToRefundAli(row);
							} else
								this.$message.info(ent.Msg);
						})
				})
			},
			ToRefundAli(row) {
				pay.RefundByAli(row.morder_id, row.order_price, true, '')
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							member.UpdateShopOrderState(row.morder_id, '3')
							row.orderstatus = '3';
							this.$message.info('退款成功！');
						} else
							this.$message.info(ent.Msg);
					})
			},
			ToShowDetail(row) {
				this.selmorderid = row.morder_id;
				this.showDetail = true;
			},
			formatdate(d) {
				return this.$moment(d).format("YYYY-MM-DD");
			},
			ToBook() {
				var data = {
					path: '/BookCusList',
					query: {
						mobile: this.userent.mobile
					},
				}
				this.$router.push(data);
			},
			InitData() {

				member.GetMyShopOrder(this.userent.mobile)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							if (ent.Data != 'null') {
								this.MOrderList = JSON.parse(ent.Data);
							}
						} else
							this.$message.info(ent.Msg);
					})
			},
			handleClick() {
				if (this.activeName == "tab1") {
					this.showtab1 = true;
					this.showtab2 = false;
					this.showtab3 = false;
				}
				if (this.activeName == "tab2") {
					this.showtab1 = false;
					this.showtab2 = true;
					this.showtab3 = false;
				}
				if (this.activeName == "tab3") {
					this.showtab1 = false;
					this.showtab2 = false;
					this.showtab3 = true;
				}
			},
			getMorders(orderstatus) {
				if (this.MOrderList.length < 1)
					return [];
				return this.MOrderList.filter(f => {
					if (f.orderstatus == orderstatus) {
						return f;
					}
				})
			},
			ToPay(row) {
				var data = {
					path: '/PayMOrder',
					query: {
						ent: row.morder_id
					}
				};
				this.$router.push(data)
			},
			CancelOrder(row) {
				member.CancelShopOrder(row.morder_id)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							let index = this.MOrderList.findIndex(function(item) {
								return item.morder_id == row.morder_id;
							})
							this.MOrderList.splice(index, 1)
						} else
							this.$message.info(ent.Msg);

					});

			}
		}
	}
</script>

<style>
</style>
